<template>
	<base-modal
		ref="$modal"
		fullscreen-on-mobile
		:height="656"
		:width="600"
		@on-close="deactivateEsc"
	>
		<div
			ref="$content"
			class="chat-avatar-modal"
		>
			<app-avatar-editor @save="onSavePhoto"/>
		</div>
	</base-modal>
</template>

<script setup lang="ts">
import { ref } from "vue";
import BaseModal from "@/components/common/modal/BaseModal.vue";
import AppAvatarEditor from "@/components/ui-kit/avatar-editor/AppAvatarEditor.vue";
import { useModalEscape } from "@/composables/useModalEscape";

const emit = defineEmits<{
	(e: 'save', value: string): void
}>()

const $modal = ref<typeof BaseModal | null>(null)
const $content = ref<HTMLElement | null>(null)

const { activate: activateEsc, deactivate: deactivateEsc } = useModalEscape({
	content: $content,
	close: () => $modal.value?.onClose()
})

const onOpen = () => {
	$modal.value?.onOpen();
	activateEsc();
}

const onSavePhoto = (url: string): void => {
	emit('save', url)
	$modal.value?.onClose();
}

defineExpose({ onOpen })
</script>

<style scoped lang="scss">
.chat-avatar-modal {
	height: 100%;
}
</style>
